import { render } from "./ShipSinkings.vue?vue&type=template&id=6512f1db"
import script from "./ShipSinkings.vue?vue&type=script&lang=js"
export * from "./ShipSinkings.vue?vue&type=script&lang=js"

import "./ShipSinkings.vue?vue&type=style&index=0&id=6512f1db&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__